import { io } from 'socket.io-client'

// Socket connects to the API host root (e.g. https://api.example.com),
// not the `/v1` REST path used by apiClient.
const getSocketBaseUrl = () => {
  const apiUrl = import.meta.env.VITE_API_URL || ''
  try {
    return new URL(apiUrl).origin
  } catch {
    return apiUrl
  }
}

let socket = null

export const connectSocket = (token) => {
  if (!token) return null

  if (socket) {
    socket.auth = { token }
    if (!socket.connected) socket.connect()
    return socket
  }

  socket = io(getSocketBaseUrl(), {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: 5,
    // Skip the HTTP long-polling handshake and connect via WebSocket directly.
    transports: ['websocket'],
  })

  // A rejected handshake (bad token, or the server's CORS allowlist not
  // including this origin) is not fatal — REST calls still work, only the
  // live push is unavailable. Log once instead of letting socket.io's
  // retry loop spam the console on every attempt.
  let hasWarned = false
  socket.on('connect_error', (error) => {
    if (hasWarned) return
    hasWarned = true
    console.warn(
      '[socket] connection failed (real-time notifications disabled):',
      error.message,
    )
  })
  socket.on('connect', () => {
    hasWarned = false
    console.log('[socket] connected:', socket.id)
  })
  socket.on('disconnect', (reason) => {
    console.log('[socket] disconnected:', reason)
  })

  return socket
}

export const disconnectSocket = () => {
  if (socket) {
    socket.removeAllListeners()
    socket.disconnect()
    socket = null
  }
}

export const getSocket = () => socket
